import { getThemeParams } from './telegram';

const KEY_MAP: Record<string, string> = {
  bg_color: '--tg-bg-color',
  text_color: '--tg-text-color',
  button_color: '--tg-button-color',
  button_text_color: '--tg-button-text-color',
  secondary_bg_color: '--tg-secondary-bg-color',
  hint_color: '--tg-hint-color',
};

export function themeParamsToCssVars(
  tp: Record<string, string>,
): Record<string, string> {
  const out: Record<string, string> = {};
  Object.entries(KEY_MAP).forEach(([tgKey, cssVar]) => {
    const value = tp?.[tgKey];
    if (typeof value === 'string' && value.length > 0) {
      out[cssVar] = value;
    }
  });
  return out;
}

export function applyTelegramTheme(): void {
  if (typeof document === 'undefined') return;
  const vars = themeParamsToCssVars(getThemeParams());
  Object.entries(vars).forEach(([cssVar, value]) => {
    document.documentElement.style.setProperty(cssVar, value);
  });
}
